'use client';

import { type RefObject, useEffect, useRef } from 'react';

export function useEnglishIqStageFocus<T extends HTMLElement>(): RefObject<T | null> {
  const stageRef = useRef<T>(null);

  useEffect(() => {
    stageRef.current?.focus();
  }, []);

  return stageRef;
}
